module.exports = __webpack_public_path__ + "img/Staffing.976c41b4.png";